import { render, staticRenderFns } from "./UtilityDetail.vue?vue&type=template&id=52429390"
import script from "./UtilityDetail.vue?vue&type=script&lang=js"
export * from "./UtilityDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports